import './StyleInput.css';

function StyleInput({
  type = 'email',
  placeholder = 'Enter your email',
}) {
  return (
    <div className="style-input">
      <input type={type}  placeholder={placeholder} />
    </div>
  );
}

export default StyleInput;
